export const SET_PAGE = 'SET_PAGE';
export const SET_COUNTRY = 'SET_COUNTRY';
export const USER_LOGOUT = "USER_LOGOUT";
export const UPDATE_COMPANY_NAME = "UPDATE_COMPANY_NAME";
export const SAVE_SESSION = "SAVE_SESSION";
export const RENEW_SESSION = "RENEW_SESSION";
export const DELETE_SESSION = "DELETE_SESSION";
export const SAVE_SESSION_REGISTER = "SAVE_SESSION_REGISTER";
export const SAVE_SESSION_DUMMY = "SAVE_SESSION_DUMMY";

export const GET_PROVIDERS = "GET_PROVIDERS";
export const SET_ACH_ACCOUNTS = "SET_ACH_ACCOUNTS";
export const UPDATE_PROVIDERS = "UPDATE_PROVIDERS";
export const SEARCH_PROVIDERS = "SEARCH_PROVIDERS";
export const PENDING_PROVIDERS = 'PENDING_PROVIDERS';
export const GET_ALL_PROVIDERS = "GET_ALL_PROVIDERS";
export const GET_PROVIDER_BY_ID = "GET_PROVIDER_BY_ID";
export const CLEAR_PROVIDER_LIST = 'CLEAR_PROVIDER_LIST';
export const GET_PROVIDERS_MODULES = "GET_PROVIDERS_MODULES";
export const PENDING_PROVIDERS_BSC = 'PENDING_PROVIDERS_BSC';
export const CLEAR_PENDING_PROVIDERS = 'CLEAR_PENDING_PROVIDERS';
export const GET_PROVIDERS_BY_CLIENT = 'GET_PROVIDERS_BY_CLIENT';

// CONSTANTS FOR BILLS ACTIONS 
export const GET_BILLS = 'GET_BILLS';
export const SEARCH_BILLS = 'SEARCH_BILLS';
export const CLEAR_BILLS_LIST = 'CLEAR_BILLS_LIST';
export const GET_PROVIDER_BILLS = 'GET_PROVIDER_BILLS';
export const GET_BILL_BY_ID = 'GET_BILL_BY_ID';

// CONSTANTS FOR COUNTRIES
export const GET_COUNTRIES = 'GET_COUNTRIES';

// CONSTANTS FOR REPORTS
export const GET_REPORT_TYPES = 'GET_REPORT_TYPES';
export const GET_REPORT_CONTENT = 'GET_REPORT_CONTENT';
export const CLEAR_REPORT_CONTENT = 'CLEAR_REPORT_CONTENT';

//CONSTATNS FOR QUESTIONS
export const GET_QUESTIONS = 'GET_QUESTIONS';

//CONSTANTS FOR USERS
export const GET_USER_ALL = 'GET_USER_ALL';
export const UPDATE_USERS = 'UPDATE_USERS';
export const PENDING_USERS = 'PENDING_USERS';
export const GET_USER_TYPES = 'GET_USER_TYPES';
export const CLEAR_ALL_USERS = 'CLEAR_ALL_USERS';
export const GET_USER_BY_CODE = 'GET_USER_BY_CODE';
export const GET_USER_DEFAULT_MODULES = 'GET_USER_DEFAULT_MODULES';
export const CLEAR_USER_BY_CODE = 'CLEAR_USER_BY_CODE';
export const CLEAR_PENDING_USERS = 'CLEAR_PENDING_USERS';
export const CLEAR_CLIENT_ACCOUNTS = 'CLEAR_CLIENT_ACCOUNTS';
export const GET_HOLIDAYS_BY_COUNTRY = 'GET_HOLIDAYS_BY_COUNTRY'
export const HANDLE_WORKING_HOURS = 'HANDLE_WORKING_HOURS'

//CONSTANTS FOR CLIENTS
export const GET_CLIENTS = "GET_CLIENTS";
export const CLEAR_WAIVERS = "CLEAR_WAIVERS";
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';
export const PENDING_CLIENTS = 'PENDING_CLIENTS';
export const GET_CLIENT_BY_CIF = 'GET_CLIENT_BY_CIF';
export const CLEAR_CLIENT_LIST = 'CLEAR_CLIENT_LIST';
export const GET_CLIENT_WAIVERS = "GET_CLIENT_WAIVERS";
export const GET_CLIENT_MODULES = 'GET_CLIENT_MODULES';
export const CLEAR_CLIENT_BY_CIF = 'CLEAR_CLIENT_BY_CIF';
export const GET_CLIENT_ACCOUNTS = 'GET_CLIENT_ACCOUNTS';
export const CLEAR_PENDING_CLIENTS = 'CLEAR_PENDING_CLIENTS';

// CONSTANTS FOR LOGS
export const GET_ALL_LOGS = 'GET_ALL_LOGS';
export const CLEAR_ALL_LOGS = 'CLEAR_ALL_LOGS';
export const GET_LOGS_ACTION_TYPES = 'GET_LOGS_ACTION_TYPES';

// CREDIT LINE && DASHBOARD SERVICES
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_CURRENCIES = 'SET_CURRENCIES';
export const GET_EMPTY_BILLS = 'GET_EMPTY_BILLS';
export const GET_CREDIT_LINE = 'GET_CREDIT_LINE';
export const CLEAR_EMPTY_BILLS = 'CLEAR_EMPTY_BILLS';
export const GET_EXPIRATION_DATES = 'GET_EXPIRATION_DATES';
export const GET_CREDIT_LINE_BY_ID = 'GET_CREDIT_LINE_BY_ID';
export const CLEAR_EXPIRATION_DATES = 'CLEAR_EXPIRATION_DATES';
export const GET_DISTRIBUTION_GRAPH = 'GET_DISTRIBUTION_GRAPH';
export const GET_CREDIT_LINE_BY_CIF = 'GET_CREDIT_LINE_BY_CIF';
export const GET_TRANSACTIONS_BY_STATUS = 'GET_TRANSACTIONS_BY_STATUS';

// NOTIFICATIONS
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const GET_NOTIFICATION_TYPES = 'GET_NOTIFICATION_TYPES';
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS';

//CifCross
export const GET_RELATED_CIF = "GET_RELATED_CIF";
export const CLEAR_RELATED_CIF = "CLEAR_RELATED_CIF";
export const GET_RELATED_COMPANIES = "GET_RELATED_COMPANIES";
export const GET_RELATED_CIF_ALLOWED = "GET_RELATED_CIF_ALLOWED";
export const CLEAR_RELATED_COMPANIES = "CLEAR_RELATED_COMPANIES";

//OTHER CONSTANTS
export const RESET_APP = 'RESET_APP';
export const GET_ENVIRONMENT = 'GET_ENVIRONMENT';
export const SET_TOKEN_DIFF = 'SET_TOKEN_DIFF';
export const GET_INSTITUTIONS_PROFILE = 'GET_INSTITUTIONS_PROFILE';
